export const emptyDatePickerPresets = {
    withAtlasToolbar: () => ({}),
    withAtlasActionBar: () => ({}),
};
//# sourceMappingURL=datePicker.js.map